<template>
  <div class="index_bottom">
    <div class="index_bottom_bac">
      <div id="JYL_footer" data-key="nemojoy" />
    </div>
  </div>
</template>

<script>
import { contentBottom } from '@/components/indexContent'

export default {
  name: 'Bottom',
  data() {
    return {
      bottom_data: {
        l: {
          c: ''
        },
        ms: [],
        us: [],
        is: []
      },
      facebookUrl: 'https://www.facebook.com/Immortal.Reborn.EN',
      discordUrl: 'https://discord.gg/qTZTcTrE39',
      cookieRef: true
    }
  },
  created() {
    this.bottom_data = contentBottom || this.bottom_data
    this.ifCookiePage()
  },
  mounted() {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://static.nemojoy.hk/libs/footer/footer.js'
    document.body.appendChild(script)
  },
  methods: {
    ifCookiePage() {
      if (this.getCookie() === '1') {
        this.cookieRef = false
        return
      }
      this.cookieRef = true
    },
    closeFun() {
      this.cookieRef = false
    },
    acceptFun() {
      this.setCookie('cookie', '1')
      this.cookieRef = false
    },
    getCookie() {
      const cookieValue = document.cookie.match(/(;)?cookie=([^;]*);?/)

      if (cookieValue == null) {
        return undefined
      } else {
        return decodeURI(cookieValue[2])
      }
    },
    setCookie(label, value) {
      const date = new Date()
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000)
      const cookieExpires = ';expires=' + date.toUTCString()
      document.cookie = label + '=' + value + cookieExpires
    }
  }
}
</script>

<style lang="scss">
.index_bottom{
  overflow: hidden;

  .index_bottom_bac {
    background: #323233;

    @media screen and (max-width: 700px) {
      #nav_style {
        display: grid;
        .f-a {
          text-align: center;
        }
      }

      #logo_style {
        text-align: center;
        img {
          width: 75%;
          height: 75%;
        }
        .f-item {
          justify-items: center;
        }
      }
      min-height: 1.8rem;
    }
    @media screen and (min-width: 700px) and (max-width: 1000px) {
      #nav_style {
        display: grid;
        .f-a {
          text-align: center;
        }
      }
      min-height: 2.6rem;
    }
  }
}
</style>
